<template>
  <b-form class="mt-3">
    <b-row>
      <b-col cols="12" md="8">
        <b-form-group label="หน่วยงาน" label-for="department">
          <vue-select
            label="text"
            v-model="department"
            :options="departments"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>

      <!-- <b-col cols="12" md="6">
        <b-form-group label="สถานะ" label-for="isSuccess">
          <vue-select
            label="text"
            v-model="isSuccess"
            :options="statusList"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col> -->

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[3]" />
      </b-col>

      <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import * as storeMaster from "@/store/api/master/index.js";
import InputFilter from "../../../filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const searchList = [
      {
        id: "departmentId",
        label: "หน่วยงาน",
        value: "",
        class: "",
        style: "",
        placeholder: "หน่วยงาน",
        type: "text",
        options: [],
      },
      {
        id: "isSucess",
        label: "สถานะ",
        value: "",
        class: "",
        style: "",
        placeholder: "สถานะ",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "วันที่ดำเนินการ",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
    ];
    return {
      search: searchList,
      props,
      departments: [],
      department: null,
      statusList: [
        { text: "ทั้งหมด", value: null },
        { text: "สำเร็จ", value: true },
        { text: "ไม่สำเร็จ", value: false },
      ],
      isSuccess: {
        text: "ทั้งหมด",
        value: null,
      },
    };
  },
  mounted() {
    this.onSearchBtnClicked();
    this.getDepartment();
  },
  methods: {
    getDepartment() {
      const _this = this;
      storeMaster
        .getDepartment(1)
        .then(function(response) {
          _this.departments = response.data.data;
          _this.department = null;

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    onResetBtnClicked() {
      this.search[0].value = null;
    },
    onSearchBtnClicked() {
      let departmentId = null;
      departmentId = this.department !== null ? this.department.value : null;
      const params = {
        departmentId,
        //isSuccess: this.isSuccess.value,
        startDate: this.search[2].value,
        endDate: this.search[3].value,
      };

      this.$emit("handleSubmit", params);
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
